export { SchemaReview as Review } from "./schemaReview";



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/schema/schema.tsx
// module id = YRSo
// module chunks = 2